import React from "react";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";

let data = [
    {
        images: '01',
        title: 'Alexandre Gotthilf',
        designation: 'CEO',
        socialNetwork: [
            {
                icon: <FaLinkedinIn />,
                url: 'https://www.linkedin.com/in/alexandre-gotthilf-ba223724/'
            },
        ]
    },
    
    // {
    //     images: '02',
    //     title: 'Paula Mendes Caldeira',
    //     designation: 'CFO',
    //     socialNetwork: [
    //         {
    //             icon: <FaLinkedinIn />,
    //             url: 'https://www.linkedin.com/in/paula-mendes-caldeira-rathsam-5435b8179/'
    //         },
    //     ]
    // },
    // {
    //     images: '03',
    //     title: 'Jose Carlos Godoi',
    //     designation: 'COO',
    //     socialNetwork: [
    //         {
    //             icon: <FaLinkedinIn />,
    //             url: 'https://br.linkedin.com/in/josecarlosgodoi/'
    //         },
    //     ]
    // },
    {
        images: '02',
        title: 'Guilherme Bueno',
        designation: 'CTO',
        socialNetwork: [
            {
                icon: <FaLinkedinIn />,
                url: 'https://www.linkedin.com/in/guilherme-b-946b8384/',
                
            },
        ]
    },
    {
        images: '03',
        title: 'Franklin Ma',
        designation: 'CFO',
        socialNetwork: [
            {
                icon: <FaLinkedinIn />,
                url: 'https://www.linkedin.com/in/franklin-m-244224/'
            },
        ]
    },
    {
        images: '04',
        title: 'Daniel Fernandes',
        designation: 'CRO',
        socialNetwork: [
            {
                icon: <FaLinkedinIn />,
                url: 'https://www.linkedin.com/in/daniel-hortence-fernandes-35472420/'
            },
        ]
    },
    
    {
        images: '10',
        title: 'Adam Smith',
        designation: 'Sr. Graphic Designer',
        socialNetwork: [
            {
                icon: <FaFacebookF />,
                url: '#'
            },
            {
                icon: <FaLinkedinIn />,
                url: '#'
            },
            {
                icon: <FaTwitter />,
                url: '#'
            },
        ]
    },

];

export default data;